import { PERMISSIONS, ROLES, getRoleName, type PermissionKey } from '@/constants';

/** @deprecated Use getRoleName from @/constants */
export const getRoleLabel = getRoleName;

export const checkPermission = (userRole: ROLES, permission: PermissionKey): boolean => {
  const allowedRoles = PERMISSIONS[permission];
  return (allowedRoles as readonly ROLES[]).includes(userRole);
};

export const isAdmin = (role: string): boolean => role === ROLES.ADMIN;
export const isHR = (role: string): boolean => role === ROLES.HR;
export const isFinance = (role: string): boolean => role === ROLES.FINANCE;
export const isApprover = (role: string): boolean => role === ROLES.APPROVER;
export const isEmployee = (role: string): boolean => role === ROLES.EMPLOYEE;

export const getHomeRoute = (role: ROLES): string => {
  switch (role) {
    case ROLES.ADMIN: return '/admin/dashboard';
    case ROLES.HR: return '/dashboard';
    case ROLES.FINANCE: return '/finance/dashboard';
    case ROLES.APPROVER: return '/my-space';
    default: return '/my-space';
  }
};
